import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hero"]

  show(event) {
    event.preventDefault()
    const el = event.currentTarget
    if (!this.hasHeroTarget) return

    const url = el.dataset.hdUrl
    if (!url) return

    const alt = el.dataset.alt || ""
    const srcset = el.dataset.hdSrcset

    const hero = this.heroTarget
    hero.src = url
    hero.alt = alt

    if (srcset) {
      hero.srcset = srcset
    } else {
      hero.removeAttribute("srcset")
    }
  }
}
